<template>
    <div class="grid">
        <div class="col-12">
            <div class="card" v-if="permission?.includes('read')">
                <Toast />
                <Error :errors="errors" />

                <Fieldset legend="Filter" :toggleable="true" :collapsed="true" class="mb-3">
                    <Filter @submit="getDataTable()" ref="filter" />
                </Fieldset>

                <DataTable :value="dataTable" responsiveLayout="scroll" :loading="loading" dataKey="number"
                    @sort="onSort($event)" :resizableColumns="true">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <div>
                                <Button :loading="loadingExcel" label="Export Excel" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('xlsx')" />
                                <Button :loading="loadingCsv" label="Export CSV" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('csv')" />
                            </div>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="search" placeholder="Cari..." @keyup.enter="getDataTable" />
                            </span>
                        </div>
                    </template>
                    <Column field="number" header="No." :style="{ width: '20px' }">
                        <template #body="slotProps">
                            {{ slotProps.data.number }}
                        </template>
                    </Column>
                    <Column field="distributor_code" header="Distributor Code">
                        <template #body="slotProps">
                            {{ slotProps.data.distributor_code }}
                        </template>
                    </Column>

                    <Column field="distributor_name" header="Distributor Name">
                        <template #body="slotProps">
                            {{ slotProps.data.distributor_name }}
                        </template>
                    </Column>

                    <Column field="username" header="Username">
                        <template #body="slotProps">
                            {{ slotProps.data.username }}
                        </template>
                    </Column>

                    <Column field="user_name" header="Name">
                        <template #body="slotProps">
                            {{ slotProps.data.user_name }}
                        </template>
                    </Column>

                    <Column field="outlet_code" header="Outlet Code">
                        <template #body="slotProps">
                            {{ slotProps.data.outlet_code }}
                        </template>
                    </Column>

                    <Column field="outlet_name" header="Outlet Name">
                        <template #body="slotProps">
                            {{ slotProps.data.outlet_name }}
                        </template>
                    </Column>

                    <Column field="market_check_date" header="Date">
                        <template #body="slotProps">
                            {{ slotProps.data.market_check_date }}
                        </template>
                    </Column>

                    <Column field="salesmanship_product_avail" header="Produk PVMI Tersedia di Toko?">
                        <template #body="slotProps">
                            {{ slotProps.data.salesmanship_product_avail }}
                        </template>
                    </Column>

                    <Column field="salesmanship_outlet_knows_salesman" header="Toko Mengenal Salesman?">
                        <template #body="slotProps">
                            {{ slotProps.data.salesmanship_outlet_knows_salesman }}
                        </template>
                    </Column>

                    <Column field="salesmanship_outlet_knows_program" header="Toko Tahu Program PVMI?">
                        <template #body="slotProps">
                            {{ slotProps.data.salesmanship_outlet_knows_program }}
                        </template>
                    </Column>

                    <Column field="salesmanship_last_visit_salesman" header="Terakhir Salesman Visit Toko">
                        <template #body="slotProps">
                            {{ slotProps.data.salesmanship_last_visit_salesman }}
                        </template>
                    </Column>

                    <Column field="visibility_homeshelf_rent" header="Implementasi Home Shelf Rent">
                        <template #body="slotProps">
                            {{ slotProps.data.visibility_homeshelf_rent }}
                        </template>
                    </Column>

                    <Column field="visibility_wholesale_rack" header="Implementasi Wholesale Rack">
                        <template #body="slotProps">
                            {{ slotProps.data.visibility_wholesale_rack }}
                        </template>
                    </Column>

                    <Column field="visibility_checkout-counter" header="Implementasi Check Out Counter">
                        <template #body="slotProps">
                            {{ slotProps.data.visibility_checkout_counter }}
                        </template>
                    </Column>

                    <Column field="visibility_pricetag" header="Implemetasi Price Tag">
                        <template #body="slotProps">
                            {{ slotProps.data.visibility_pricetag }}
                        </template>
                    </Column>

                    <Column field="visibility_framing" header="Implementasi Framing">
                        <template #body="slotProps">
                            {{ slotProps.data.visibility_framing }}
                        </template>
                    </Column>

                    <Column field="visibility_dominant" header="Visibility Dominan">
                        <template #body="slotProps">
                            {{ slotProps.data.visibility_dominant }}
                        </template>
                    </Column>

                    <Column field="product_msl_mentosmonomint" header="Mentos Mono Mint">
                        <template #body="slotProps">
                            {{ slotProps.data.product_msl_mentosmonomint }}
                        </template>
                    </Column>

                    <Column field="product_msl_mentosmonobuah" header="Mentos Mono Buah">
                        <template #body="slotProps">
                            {{ slotProps.data.product_msl_mentosmonobuah }}
                        </template>
                    </Column>

                    <Column field="product_msl_ccbbmonostrawberry" header="CC BB Mono Strawberry">
                        <template #body="slotProps">
                            {{ slotProps.data.product_msl_ccbbmonostrawberry }}
                        </template>
                    </Column>

                    <Column field="product_msl_ccbbmonoastrd" header="CC BB Mono Astrd">
                        <template #body="slotProps">
                            {{ slotProps.data.product_msl_ccbbmonoastrd }}
                        </template>
                    </Column>

                    <Column field="product_msl_alpenmonocaramel" header="Alpenliebe Mono Caramel">
                        <template #body="slotProps">
                            {{ slotProps.data.product_msl_alpenmonocaramel }}
                        </template>
                    </Column>

                    <Column field="product_msl_alpenlolyoriginal" header="Alpenliebe Lolly Original">
                        <template #body="slotProps">
                            {{ slotProps.data.product_msl_alpenlolyoriginal }}
                        </template>
                    </Column>

                    <Column field="product_msl_ccsourbelt" header="CC Sour Belt">
                        <template #body="slotProps">
                            {{ slotProps.data.product_msl_ccsourbelt }}
                        </template>
                    </Column>

                    <Column field="product_strategic_mentosrollmint" header="Mentos Roll Mint">
                        <template #body="slotProps">
                            {{ slotProps.data.product_strategic_mentosrollmint }}
                        </template>
                    </Column>

                    <Column field="product_strategic_mentosrollbuah" header="Mentos Roll Buah">
                        <template #body="slotProps">
                            {{ slotProps.data.product_strategic_mentosrollbuah }}
                        </template>
                    </Column>

                    <Column field="product_strategic_ccbbstickhanger" header="CC BB Stick Hanger TF, SC, BB">
                        <template #body="slotProps">
                            {{ slotProps.data.product_strategic_ccbbstickhanger }}
                        </template>
                    </Column>

                    <Column field="product_strategic_ccclassicjar" header="CC Classic Jar">
                        <template #body="slotProps">
                            {{ slotProps.data.product_strategic_ccclassicjar }}
                        </template>
                    </Column>

                    <Column field="product_strategic_alpeeclairmono" header="Alpenliebe Eclair Mono">
                        <template #body="slotProps">
                            {{ slotProps.data.product_strategic_alpeeclairmono }}
                        </template>
                    </Column>

                    <Column field="product_strategic_alpenmonostrawberry" header="Alpenliebe Mono Strawberry">
                        <template #body="slotProps">
                            {{ slotProps.data.product_strategic_alpenmonostrawberry }}
                        </template>
                    </Column>

                    <Column field="product_strategic_alpenlolystrawberry" header="Alpenliebe Lolly Strawberry">
                        <template #body="slotProps">
                            {{ slotProps.data.product_strategic_alpenlolystrawberry }}
                        </template>
                    </Column>

                    <Column field="product_strategic_mfamono" header="MFA Mono">
                        <template #body="slotProps">
                            {{ slotProps.data.product_strategic_mfamono }}
                        </template>
                    </Column>

                    <Column field="product_strategic_happydentsmall" header="Happydent Small Mono">
                        <template #body="slotProps">
                            {{ slotProps.data.product_strategic_happydentsmall }}
                        </template>
                    </Column>

                    <Column field="competitor_product_meilkitalolly" header="Milkita Lolly">
                        <template #body="slotProps">
                            {{ slotProps.data.competitor_product_meilkitalolly }}
                        </template>
                    </Column>

                    <Column field="competitor_product_kopiko" header="Kopiko">
                        <template #body="slotProps">
                            {{ slotProps.data.competitor_product_kopiko }}
                        </template>
                    </Column>

                    <Column field="competitor_product_relaxa" header="Relaxa">
                        <template #body="slotProps">
                            {{ slotProps.data.competitor_product_relaxa }}
                        </template>
                    </Column>

                    <Column field="competitor_product_kiss" header="Kiss">
                        <template #body="slotProps">
                            {{ slotProps.data.competitor_product_kiss }}
                        </template>
                    </Column>

                    <Column field="competitor_product_yupi" header="Yupi">
                        <template #body="slotProps">
                            {{ slotProps.data.competitor_product_yupi }}
                        </template>
                    </Column>

                    <Column field="competitor_product_longbar" header="Longbar">
                        <template #body="slotProps">
                            {{ slotProps.data.competitor_product_longbar }}
                        </template>
                    </Column>

                    <Column field="competitor_product_xylitol" header="Xylitol">
                        <template #body="slotProps">
                            {{ slotProps.data.competitor_product_xylitol }}
                        </template>
                    </Column>

                    <Column field="competitor_product_ranjani" header="Ranjani">
                        <template #body="slotProps">
                            {{ slotProps.data.competitor_product_ranjani }}
                        </template>
                    </Column>

                    <Column field="competitor_product_permencina" header="Permen Cina">
                        <template #body="slotProps">
                            {{ slotProps.data.competitor_product_permencina }}
                        </template>
                    </Column>

                    <Column field="competitor_programtemuan" header="Program Photo">
                        <template #body="slotProps">
                            <Image v-if="slotProps.data.competitor_programtemuan != 'null'"
                                :src="slotProps.data.competitor_programtemuan"
                                :alt="slotProps.data.competitor_programtemuan" width="100" preview />
                        </template>
                    </Column>

                    <Column field="competitor_programdetail" header="Program Keterangan">
                        <template #body="slotProps">
                            {{ slotProps.data.competitor_programdetail }}
                        </template>
                    </Column>

                    <Column field="marketinsight_product" header="Market Insight - Nama Produk">
                        <template #body="slotProps">
                            {{ slotProps.data.marketinsight_product }}
                        </template>
                    </Column>

                    <Column field="marketinsight_hargabeligrosir" header="Market Insight - Harga Beli Grosir">
                        <template #body="slotProps">
                            {{ slotProps.data.marketinsight_hargabeligrosir }}
                        </template>
                    </Column>

                    <Column field="marketinsight_hargajualgrosir" header="Market Insight - Harga Jual Grosir">
                        <template #body="slotProps">
                            {{ slotProps.data.marketinsight_hargajualgrosir }}
                        </template>
                    </Column>

                    <Column field="marketinsight_hargajualeceran" header="Market Insight - Harga Jual Eceran">
                        <template #body="slotProps">
                            {{ slotProps.data.marketinsight_hargajualeceran }}
                        </template>
                    </Column>

                    <Column field="marketinsight_konfigurasi" header="Market Insight - Konfigurasi">
                        <template #body="slotProps">
                            {{ slotProps.data.marketinsight_konfigurasi }}
                        </template>
                    </Column>

                    <Column field="marketinsight_dokumentasitemuan" header="Market Insight - Dokumentasi Temuan">
                        <template #body="slotProps">
                            <Image v-if="slotProps.data.marketinsight_dokumentasitemuan != 'null'"
                                :src="slotProps.data.marketinsight_dokumentasitemuan"
                                :alt="slotProps.data.marketinsight_dokumentasitemuan" width="100" preview />
                        </template>
                    </Column>

                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait. </template>
                    <template #footer>
                        In total there are {{ totalItemsCount ? totalItemsCount : 0 }} data.
                    </template>
                </DataTable>

                <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount"
                    :rowsPerPageOptions="[10, 20, 30]">
                    <template>
                        {{ totalItemsCount }}
                    </template>
                </Paginator>

            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { numberingDatatable } from "../../utils/helpers";
import Filter from "../../components/report/market-check/Filter.vue";
import Error from "../../components/Error.vue";

export default {
    components: {
        Filter: Filter,
        Error: Error
    },
    data() {
        return {
            // loading
            loading: false,
            loadingExcel: false,
            loadingCsv: false,

            //datatables
            data: null,
            dataTable: null,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,

            // edit
            item: {},
        };
    },
    mounted() {
        const waitForRef = setInterval(() => {
            if (this.$refs.filter) {
                clearInterval(waitForRef);
                this.getDataTable();
            }
        }, 100);
        this.$store.commit("setErrors", {});
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        },
    },
    computed: {
        ...mapGetters(["errors"]),
        ...mapGetters("auth", ["permission"]),
    },
    methods: {
        formatDate(value) {
            if (value) {
                return moment.utc(value).format("DD-MM-YYYY");
            }
        },
        // DATATABLE
        getDataTable() {
            this.loading = true;
            if (this.$refs?.filter) {
                this.$refs.filter.loading = true;
            }
            this.page = this.offset / this.rows + 1;

            this.axios({
                method: "GET",
                url: process.env.VUE_APP_ROOT_API + "web/market-check",
                params: {
                    search: this.search,
                    per_page: this.rows,
                    page: this.page,
                    order_by: this.field,
                    sort_by: this.sort,
                    userid: this.$refs?.filter?.filters.userid,
                    start_date: this.$refs?.filter?.period_start_label,
                    end_date: this.$refs?.filter?.period_end_label,
                },
            })
                .then((res) => {
                    this.data = res.data.data.data;
                    this.dataTable = numberingDatatable(
                        res.data.data.data,
                        this.page,
                        this.rows
                    );
                    this.totalItemsCount = res.data.data.total;
                    this.rows = parseInt(res.data.data.per_page);
                    this.loading = false;
                    this.$refs.filter.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$refs.filter.loading = false;
                });
        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == "1" ? "ASC" : "DESC";
            this.getDataTable();
        },
        // EXPORT
        exportExcelCSV(ext) {
            if (
                this.$refs?.filter?.period_start_label !== null &&
                this.$refs?.filter?.period_end_label !== null &&
                this.$refs?.filter?.period_start_label !== "Invalid date" &&
                this.$refs?.filter?.period_end_label !== "Invalid date"
            ) {
                if (ext == "xlsx") {
                    this.loadingExcel = true;
                } else if (ext == "csv") {
                    this.loadingCsv = true;
                }

                this.axios({
                    method: "GET",
                    url: process.env.VUE_APP_ROOT_API + "web/market-check/export",
                    responseType: "blob",
                    params: {
                        ext: ext,
                        userid: this.$refs?.filter?.filters.userid,
                        start_date: this.$refs?.filter?.period_start_label,
                        end_date: this.$refs?.filter?.period_end_label,
                    },
                })
                    .then((response) => {
                        let fileUrl = window.URL.createObjectURL(response.data);
                        let fileLink = document.createElement("a");

                        fileLink.href = fileUrl;

                        fileLink.setAttribute("download", "Report Market check Export." + ext);

                        document.body.appendChild(fileLink);

                        fileLink.click();

                        if (ext == "xlsx") {
                            this.loadingExcel = false;
                        } else if (ext == "csv") {
                            this.loadingCsv = false;
                        }
                    })
                    .catch((err) => {
                        console.log(err);

                        if (ext == "xlsx") {
                            this.loadingExcel = false;
                        } else if (ext == "csv") {
                            this.loadingCsv = false;
                        }
                    });
            } else {
                alert("Pastikan rentang waktu sudah benar atau tidak kosong");
            }
        },
    },
};
</script>
